(function () {
  const CREDIT_URL = "https://lirogo.com/shopify/";

  function exists() {
    return !!document.querySelector('a[href="' + CREDIT_URL + '"]');
  }

  function insert() {
    if (exists()) return;

    const aside = document.querySelector('.footer__aside .v-stack.gap-3') || document.querySelector('.footer__aside');
    if (!aside) return;

    const p = document.createElement('p');
    p.className = 'text-sm';
    p.id = 'lirogo-credit';
    p.innerHTML = 'Desarrollado por <a href="' + CREDIT_URL + '" target="_blank">Lirogo Digital</a>';

    const copyrightP = aside.querySelector('p.text-sm');
    if (copyrightP) {
      copyrightP.insertAdjacentElement('afterend', p);
    } else {
      aside.appendChild(p);
    }
  }

  document.addEventListener('DOMContentLoaded', insert);
  window.addEventListener('load', function () {
    insert();
    new MutationObserver(function () {
      if (!exists()) insert();
    }).observe(document.body, { childList: true, subtree: true });
  });
})();